import PropTypes from "prop-types";
import React from "react";

export const Agriculture = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M 4.9990070722682765 32.51698380925837  L 5.012795653599364 32.51017305597081  C 5.426453093531919 32.06747409227963  5.840110533464475 31.624775128588446  6.239979392065946 31.161643905034595  C 8.425469533042948 28.641665188638612  10.328293756732705 25.876499353890598  11.776094796496652 22.893389413940763  C 13.244578708257224 19.91709022727849  14.20977940143319 16.702414675551733  14.623436841365741 13.38557782451162  C 15.016411409301673 10.484196924012469  14.926785630649618 7.507897737350193  14.54070535337923 4.490734030962578  L 14.850948433328648 5.505536270808524  C 15.023305699967212 6.4590417310664625  15.16808580394361 7.4193579446119555  15.271500163926746 8.372863404869893  C 15.368020233244344 9.24463982567715  15.409385977237598 10.116416246484407  15.436963139899769 10.988192667291662  L 15.450751721230853 12.29585729850255  L 15.409385977237598 13.596711176425877  C 15.209451547936865 17.07019535307979  14.51312819071706 20.496004256720806  13.29283874291602 23.744733574885355  C 12.686141164348271 25.365692857323847  11.9622406444663 26.945787620037  11.134925764601187 28.471396356449695  C 10.321399466067161 29.997005092862395  9.397564516884453 31.46812780297464  8.377209498384149 32.87114298021132  C 8.142803615755701 33.19124838472648  7.894609151796168 33.511353789241646  7.646414687836633 33.83145919375681  C 5.771167626809046 36.24927661083944  3.620148939159756 38.46958218258292  1.1726757528921334 40.24718879063522  L 1.6070160648213168 40.83972432665265  L 2.2481850967167785 41.71831150074746  C 5.109315722916958 39.647842501330224  7.5016345838602385 37.066567005346236  9.507873167533134 34.253725897585326  C 24.937295677017467 36.86224440671954  28.36375813779214 13.984924113816604  13.230790126926136 0.29531000582765154  C 13.50656175354784 9.026695720475331  4.399203784366069 12.173263739326526  1.420870216851668 20.019251526591837  C 0.04890637440869082 23.635761522284444  0.2557350943749688 29.152471685205363  4.9990070722682765 32.51698380925837  Z " />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "-10 0 42 42",
    };
  }
};

Agriculture.displayName = "AgricultureIcon";

Agriculture.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

Agriculture.defaultProps = { role: "img" };
